function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1600",
  height: "1600",
  viewBox: "0 0 1200 1200",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M330 276c36.445 0 66-29.555 66-66V102c0-36.445-29.555-66-66-66s-66 29.555-66 66v108c0 36.445 29.555 66 66 66zm540 0c36.445 0 66-29.555 66-66V102c0-36.445-29.555-66-66-66s-66 29.555-66 66v108c0 36.445 29.555 66 66 66zm270-132H972v78c0 56.328-45.672 102-102 102s-102-45.672-102-102v-78H432v78c0 56.328-45.672 102-102 102s-102-45.672-102-102v-78H60c-33.145 0-60 26.855-60 60v936c0 33.145 26.855 60 60 60h1080c33.145 0 60-26.855 60-60V204c0-33.145-26.855-60-60-60zm-615 888L276 780l75-78 174 162 324-348 87 72z",
  fill: "currentColor"
})));